import styled from "@emotion/styled";

export const Container = styled.div`
    display: flex;
    padding: 0px;
    position: absolute;
    right: 24px;
    bottom: 24px;
    
    @media screen and (max-width: 768px) {
        left: 0;
        right: 0;
        justify-content: space-evenly;
    }
    
`;

export const InnerContainer = styled.div`
    display: flex;
    padding: 0px;
    position: relative;
    
    background: rgba(0, 0, 0, 0.7);
    backdrop-filter: blur(4px);
    
    > * {
        z-index: 1;
        margin: 0;
        box-sizing: border-box;
        order: 1;
        flex-grow: 0;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: flex-end;
        padding: 18px 24px;
        isolation: isolate;
        position: relative;

        &::before {
            content: '';
            display: block;
            position: absolute;
            pointer-events: none;
            box-sizing: border-box;
    
            left: 4px;
            right: 4px;
            top: 4px;
            bottom: 4px;
    
            border: 1px solid rgba(255, 255, 255, 0.15);
        }
    }      
`;